
  <div class="modal-header">
    <h5 class="modal-title" id="newUserLabel" i18n="@@CreateNewCustomerHeader">Neuen Kunden anlegen</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="onCancelClick()"></button>
  </div>
  <div class="modal-body">
    <form class="was-validated hide-valid-feedback" [formGroup]="formService.form" autocomplete="off" novalidate
          (ngSubmit)="registerUserFromOperator(formService.form.value)" *ngIf="formCreated">
      <div class="justify-content-center">
        <div class="justify-content-center">
          <app-message [service]="messageService"></app-message>
        </div>

        <div class="container justify-content-center round">
          <div class="col-lg-12 col-md-12">
            <div class="row justify-content-center">
              <div class=" col-md-12 col-lg-10 col-12 mt-3">
                <div class="form-group">

                  <label class="persistent" for="type">Privat / Geschäftlich*</label>
                  <select id="type" formControlName="type" class="form-control form-select">
                    <option value="private" i18n="@@PrivateUserOption">Privat</option>
                    <option value="company" i18n="@@BusinessUserOption">Geschäftlich</option>
                  </select>
                </div>

                <div *ngIf="isTypeCompany()" class="form-group">
                  <label class="persistent" for="company" i18n="@@CompanyLabel">Unternehmen*</label>
                  <input type="text" id="company" formControlName="company" class="form-control"
                         [ngClass]="{ 'is-invalid': formService.validateControl('company') }" />

                  <div class="invalid-tooltip"
                       *ngIf="formService.validateControl('company') && formService.hasError('company', 'required')"
                       i18n="@@CompanyRequiredError">
                    Unternehmen wird benötigt
                  </div>

                </div>

              </div>
              <div class="col-lg-5 col-md-6 col-sm-12">
                <div class="form-group">

                  <div FormGroupName="UserName">

                    <div class="form-group position-relative">
                      <label class="persistent" for="gender" i18n="@@TitleLabel">Anrede*</label>
                      <select id="gender" formControlName="gender" class="form-control form-select"
                              [ngClass]="{ 'is-invalid': formService.validateControl('gender') }">
                        <option value="male" i18n="@@TitleMrOption">Herr</option>
                        <option value="female" i18n="@@TitleMrs_MsOption">Frau</option>
                        <option value="diverse" i18n="@@TitleDiversOption">Divers</option>
                      </select>
                      <div class="invalid-tooltip"
                           *ngIf="formService.validateControl('gender') && formService.hasError('gender', 'required')"
                           i18n="@@TitleRequiredError">
                        Anrede wird benötigt
                      </div>
                    </div>

                    <div class="form-group position-relative">
                      <label class="persistent" for="firstName" i18n="@@FirstnameLabel">Vorname*</label>
                      <input type="text" id="firstName" formControlName="firstName" class="form-control"
                             [ngClass]="{ 'is-invalid': formService.validateControl('firstName') }" />
                      <div class="invalid-tooltip"
                           *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'required')"
                           i18n="@@FirstnameRequiredError">
                        Vorname wird benötigt
                      </div>
                      <div class="invalid-tooltip"
                           *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'pattern')"
                           i18n="@@IncorrectInputError">
                        Falsche Eingabe
                      </div>
                      <div class="invalid-tooltip"
                           *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'maxlength')"
                           i18n="@@ExceededMaxLengthError">
                        Die Eingabe darf maximal 50 Zeichen lang sein
                      </div>
                    </div>

                    <div class="form-group position-relative">
                      <label class="persistent" for="lastName" i18n="@@LastnameLabel">Nachname*</label>
                      <input type="text" id="lastName" formControlName="lastName" class="form-control"
                             [ngClass]="{ 'is-invalid': formService.validateControl('lastName') }" />
                      <div class="invalid-tooltip"
                           *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'required')"
                           i18n="@@LastnameRequiredError">
                        Nachname wird benötigt
                      </div>
                      <div class="invalid-tooltip"
                           *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'pattern')"
                           i18n="@@IncorrectInputError">
                        Falsche Eingabe
                      </div>
                      <div class="invalid-tooltip"
                           *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'maxlength')"
                           i18n="@@ExceededMaxLengthError">
                        Die Eingabe darf maximal 50 Zeichen lang sein
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-lg-5 col-md-6 col-sm-12">
                <div class="form-row">

                  <div formGroupName="address">
                    <div class="form-row">
                      <div class="form-group position-relative col-8">
                        <label class="persistent" for="street" i18n="@@StreetLabel">Straße*</label>
                        <input type="text" id="street" formControlName="street" class="form-control"
                               [ngClass]="{ 'is-invalid': formService.validateControl('address.street') }" />
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'required')"
                             i18n="@@StreetRequiredError">
                          Straße wird benötigt
                        </div>
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'pattern')"
                             i18n="@@IncorrectInputError">
                          Falsche Eingabe
                        </div>
                      </div>

                      <div class="form-group position-relative col-4">
                        <label class="persistent" for="houseNumber" i18n="@@HousnumberLabel">Hausnummer*</label>
                        <input type="text" id="houseNumber" formControlName="houseNumber" class="form-control"
                               [ngClass]="{ 'is-invalid': formService.validateControl('address.houseNumber') }" />
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.houseNumber') && formService.hasError('address.houseNumber', 'required')"
                             i18n="@@HousnumberRequiredError">
                          Hausnummer wird benötigt
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group position-relative col-4">
                        <label class="persistent" for="postalCode" i18n="@@PostalCodeLabel">PLZ*</label>
                        <input type="text" id="postalCode" formControlName="postalCode" class="form-control"
                               [ngClass]="{ 'is-invalid': formService.validateControl('address.postalCode') }" />

                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'required')"
                             i18n="@@postalCodeRequiredError">
                          PLZ wird benötigt
                        </div>
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'pattern')"
                             i18n="@@IncorrectInputError">
                          Falsche Eingabe
                        </div>
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'maxlength')"
                             i18n="@@ExceededMaxLengthPLZError">
                          PLZ zu lang
                        </div>
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'minlength')"
                             i18n="@@MissingNumbersPLZError">
                          PLZ zu kurz
                        </div>
                      </div>

                      <div class="form-group position-relative col-8">
                        <label class="persistent" for="city" i18n="@@CityLabel">Ort*</label>
                        <input type="text" id="city" formControlName="city" class="form-control"
                               [ngClass]="{ 'is-invalid': formService.validateControl('address.city') }" />
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'required')"
                             i18n="@@CityRequiredError">
                          Ort wird benötigt
                        </div>
                        <div class="invalid-tooltip"
                             *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'pattern')"
                             i18n="@@IncorrectInputError">
                          Falsche Eingabe
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="form-row">
                  <div class="form-group position-relative col-12">
                    <label class="persistent" for="phone" i18n="@@PhoneLabel">Telefonnummer*</label>
                    <input type="text" id="phone" formControlName="phone" class="form-control"
                           [ngClass]="{ 'is-invalid': formService.validateControl('phone') }" />
                    <div class="invalid-tooltip"
                         *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'required')"
                         i18n="@@PhonenumberRequiredError">
                      Telefonnummer wird benötigt
                    </div>
                    <div class="invalid-tooltip"
                         *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'pattern')"
                         i18n="@@IncorrectInputError">
                      Falsche Eingabe
                    </div>
                    <div class="invalid-tooltip"
                         *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'minlength')"
                         i18n="@@MinLengthError">
                      Telefonnummer zu kurz
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-lg-12 col-md-12">
            <div class="row justify-content-center">
              <div class="col-lg-10 col-12">
                <hr>
              </div>
              <div class=" col-lg-10 col-12">
                <div class="form-group position-relative">
                  <label class="persistent" for="email" i18n="@@E-MailLabel">E-Mail*</label>
                  <input type="email" id="email" formControlName="email" class="form-control" [readonly]="token != null" [ngClass]="{ 'is-invalid': formService.validateControl('email') }" />
                  <div class="invalid-tooltip" *ngIf="formService.validateControl('email') && formService.hasError('email', 'required')" i18n="@@E-mailRequiredError">
                    E-Mail wird benötigt
                  </div>
                  <div class="invalid-tooltip" *ngIf="formService.validateControl('email') && formService.hasError('email', 'email')" i18n="@@IncorrectInputError">
                    Falsche Eingabe
                  </div>
                </div>
              </div>
              <div class=" col-lg-10 col-12">
                <div class="form-group position-relative">
                  <!-- <label class="persistent" for="password" data-toggle="tooltip" i18n="@@ChoosePasswordLabel">Passwort* <span *ngIf="passwordRating != ''" [class]="'password-rating-' + passwordQuality">({{ passwordRating }})</span></label> -->
                  <label class="persistent" for="password" data-toggle="tooltip" i18n="@@ChoosePasswordLabel">Passwort*</label>
                  <input type="password" id="password" formControlName="password" (keyup)="checkPassword($event.target.value)" class="form-control" [ngClass]="{ 'is-invalid': formService.validateControl('password') }" [readonly]="isOperatorView" />
                  <div class="invalid-tooltip" *ngIf="formService.validateControl('password') && formService.hasError('password', 'required')" i18n="@@PasswordRequiredError">
                    Passwort wird benötigt
                  </div>
                </div>
              </div>
              <div class=" col-lg-10 col-12">
                <div class="form-group position-relative">
                  <div class="password-requirements">
                    <span [class]="passwordHasUpperCase ? 'check' : ''">Großbuchstabe</span>
                    <span [class]="passwordHasLowerCase ? 'check' : ''">Kleinbuchstabe</span>
                    <span [class]="passwordHasDigit ? 'check' : ''">Ziffer</span>
                    <span [class]="passwordHasLength ? 'check' : ''">10 Zeichen lang</span>
                    <span *ngIf="passwordHasSpecialCharacter" [class]="passwordHasSpecialCharacter ? 'check' : ''">Sonderzeichen</span>
                  </div>
                </div>
              </div>
              <div class=" col-lg-10 col-12">
                <div class="form-group position-relative">
                  <label class="persistent" for="confirm" i18n="@@ConfirmPasswordLabel">Passwort wiederholen*</label>
                  <input type="password" id="confirm" formControlName="confirm" class="form-control" [ngClass]="{ 'is-invalid': formService.validateControl('confirm') }" [readonly]="isOperatorView" />
                  <div class="invalid-tooltip" *ngIf="formService.validateControl('confirm') && formService.hasError('confirm', 'matching')" i18n="@@PasswordsNotIdenticError">
                    Passwörter müssen übereinstimmen
                  </div>
                </div>

              </div>

            </div>

          </div>
          <div class="row justify-content-center mt-2 d-none">
            <div class=" col-lg-10 col-md-6 col-12 text-left">
              <div class="form-inline position-relative">
                <input type="checkbox" id="acceptTos" formControlName="acceptTos" class="ms-2 form-check-input"
                       [ngClass]="{ 'is-invalid': formService.validateControl('acceptTos') }" />
                <label class="form-check-label persistent ms-2" for="acceptTos" i18n="@@AcceptTermsAndConditionsLabel">
                  Ich stimme den&nbsp;
                  <a data-bs-toggle="modal" data-bs-target="agbModal" (click)="openAGBDialog();">AGB</a>
                  &nbsp; zu.*
                </label>
                <div class="invalid-tooltip"
                     *ngIf="formService.validateControl('acceptTos') && formService.hasError('acceptTos', 'required')"
                     i18n="@@AcceptTermsAndConditionsRequiredError">
                  AGB Bestätigung wird benötigt
                </div>
              </div>

              <div class="form-inline position-relative">
                <input type="checkbox" id="acceptPrivacy" formControlName="acceptPrivacy" class="ms-2 form-check-input"
                       [ngClass]="{ 'is-invalid': formService.validateControl('acceptPrivacy') }" />
                <label class="form-check-label persistent ms-2" for="acceptPrivacy" i18n="@@AcceptPrivacyLabel">
                  Ich stimme den Bedingungen des&nbsp;
                  <a data-bs-toggle="modal" data-bs-target="dsModal" (click)="openDSDialog();">Datenschutzes</a>
                  &nbsp; zu.*
                </label>
                <div class="invalid-tooltip"
                     *ngIf="formService.validateControl('acceptPrivacy') && formService.hasError('acceptPrivacy', 'required')"
                     i18n="@@AcceptPrivacyRequiredError">
                  Datenschutz Bestätigung wird benötigt
                </div>
              </div>

              <div class="form-group">
                <input type="checkbox" id="acceptAd" formControlName="acceptAd" class="ms-2 form-check-input" />
                <label for="acceptAd" class="label persistent ms-4" i18n="@@AcceptAd">
                  Ich bin damit einverstanden, neue Informationen über Produkte der CUBOS Service GmbH per E-Mail zu erhalten.
                </label>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center mt-12">
        <div class="col-md-12 col-lg-10 col-12">
          <div class="mb-2 mt-4">
            <button type="submit" class="w-100 btn btn-lg btn-yellow " [disabled]="!formService.form.valid"
                    i18n="@@NowRegisterButton">
              Jetzt anlegen
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
<router-outlet></router-outlet>
